<template>
  <div class="question-rich-text">
    <input-html
        style="height: 40px;"
        :disabled="disabled"
        v-model="currentValue"
        :icon="prefixIcon"
        :placeholder="placeholder"></input-html>
    <div v-if="!disabled"
         class="question-rich-text-footer">
      <el-tooltip content="编辑富文本格式"
                  placement="top">
        <el-button type="text"
                   size="mini"
                   icon="el-icon-edit"
                   style="padding: 0;"
                   @click.stop="showRichTextEditor"></el-button>
      </el-tooltip>
    </div>
  </div>
</template>

<script>
import InputHtml from '@/views/question-editor/components/InlineInputHtml'
import QuestionEditor from '@/views/question-editor/components/question-quill-editor'

export default {
  components: {InputHtml},
  inject: ['page', 'SjQuestion'],
  props: {
    value: String,
    prefixIcon: String,
    disabled: Boolean,
    plainPaste: {
      type: Boolean,
      default: true,
    },
    placeholder: {
      type: String,
      default: '',
    },
    toolbar: {
      type: Array,
      default: () => {
        return [
          [{'color': ['', '#F00']}]
        ]
      }
    }
  },
  data () {
    return {}
  },
  computed: {
    currentValue: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      },
    },
  },
  watch: {},
  created () {},
  mounted () {},
  destroyed () {},
  methods: {
    showRichTextEditor () {
      let text = this.$el.getBoundingClientRect()
      // 获得容器的相对屏幕的位置信息
      let container = this.SjQuestion.$el
      let question = container.getBoundingClientRect()
      // 获得文本框的宽度，小于500px时将会产生换行
      let offsetHeight = 32
      if (text.width < 500) {
        offsetHeight = 63
      }
      // 获得绝对坐标
      let top = text.top - question.top - offsetHeight
      let left = text.left - question.left
      QuestionEditor.open(this.currentValue, {
        container,
        style: {
          top: top + 'px',
          left: left + 'px',
          width: text.width - 2 + 'px',
          height: '70px',
        },
        callback: ({html}) => {
          this.currentValue = $(html).html()
        },
        options: {
          bounds: $('#main')[0],
          placeholder: this.placeholder,
          modules: {
            toolbar: this.toolbar
          }
        },
        plainPaste: this.plainPaste,
      })
    },
  },
  filters: {},
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
.question-rich-text {
  position: relative;
  line-height: normal;

  .question-rich-text-footer {
    position: absolute;
    bottom: 5px;
    right: 5px;
    opacity: 0;
    transition: 0.1s opacity ease-in;
  }

  &:hover .question-rich-text-footer {
    opacity: 1;
  }
}
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/question-editor/packages/sj-question-inline-rich-text/src/SjQuestionInlineRichText.vue